import { Box } from "@mui/material";
import React from "react";
import ZohoAuthentication from "./ZohoAuthentication";
import Title from "../../atoms/Title";
import Paragraph from "../../atoms/Paragraph";
import { EXTENSION_IDENTIFIER } from "../../config/serviceConstant";
import ZohoUserAuthentication from "./ZohoUserAuthentication";
import { ZohoAuthPageTable } from "./ZohoAuthPageTable";

function ZohoAuthenticationPage({
  zohoAuth,
  setZohoAuth,
  orgId,
  apiKey,
  dataCenterUrl,
  dataCenter,
  zuid,
  setZuid,
  zApiKey,
  connName,
  users,
  currentUser,
  useLoginUserCredential,
  authenticatedUserMap,
  setAuthenticatedUserMap,
  defaultAuthenticator,
  setSnack,
}) {
  return (
    <Box
      container
      sx={{
        borderRadius: "8px",
        border: "1px solid #cccccc",
        mb: "1rem",
        p: "20px",
      }}
    >
      <Title>Authenticate ZOHO Service</Title>
      <Paragraph>
        Workdrive Extension require to fetch/modify Record's Details and fields
        metadata of modules. To perform these, it requires Zoho CRM and
        Workdrive Service authenticate. Please click the button below to
        Authenticate Zoho CRM and Workdrive Service
      </Paragraph>

      {!useLoginUserCredential ? (
        <ZohoAuthentication
          zohoAuth={zohoAuth}
          setZohoAuth={setZohoAuth}
          orgId={orgId}
          apiKey={apiKey}
          dataCenterUrl={dataCenterUrl}
          currentUser={currentUser}
          defaultAuthenticator={defaultAuthenticator}
          authenticatedUserMap={authenticatedUserMap}
          setAuthenticatedUserMap={setAuthenticatedUserMap}
          zuid={zuid}
          setZuid={setZuid}
          dataCenter={dataCenter}
          connName={connName}
          zApiKey={zApiKey}
          setSnack={setSnack}
          key={"256"}
        />
      ) : (
        <>
          <ZohoAuthPageTable
            rows={users}
            currentUser={currentUser}
            defaultAuthenticator={defaultAuthenticator}
            authenticatedUserMap={authenticatedUserMap}
            zohoAuthenticationButton={({ user, index }) => (
              <ZohoAuthentication
                zohoAuth={zohoAuth}
                setZohoAuth={setZohoAuth}
                orgId={orgId}
                apiKey={apiKey}
                dataCenterUrl={dataCenterUrl}
                zuid={zuid}
                setZuid={setZuid}
                dataCenter={dataCenter}
                currentUser={currentUser}
                defaultAuthenticator={defaultAuthenticator}
                authenticatedUserMap={authenticatedUserMap}
                setAuthenticatedUserMap={setAuthenticatedUserMap}
                connName={`${EXTENSION_IDENTIFIER}__zoho__${user?.email}`}
                zApiKey={zApiKey}
                setSnack={setSnack}
                key={index}
              />
            )}
            zohoUserAuthenticationButton={({ user, index }) => (
              <ZohoUserAuthentication
                key={index}
                userAuth={authenticatedUserMap?.[user?.email] ? true : false}
                // setZohoAuth={setZohoAuth}
                orgId={orgId}
                apiKey={apiKey}
                dataCenterUrl={dataCenterUrl}
                zuid={zuid}
                setZuid={setZuid}
                dataCenter={dataCenter}
                defaultAuthenticator={defaultAuthenticator}
                authenticatedUserMap={authenticatedUserMap}
                setAuthenticatedUserMap={setAuthenticatedUserMap}
                connName={`${EXTENSION_IDENTIFIER}__zoho__${user?.email}`}
                zApiKey={zApiKey}
                currentUser={currentUser}
                useLoginUserCredential={useLoginUserCredential}
                user={user}
                setSnack={setSnack}
              />
            )}
          />
        </>
      )}
    </Box>
  );
}

export default ZohoAuthenticationPage;
